import { api } from './api';

export type HlSpan = [number, number];

// 统一「纯关键词去重词条」：点击任意词条进高级搜索 /search?q=text。
export interface SuggestTerm {
  text: string;
  hl: HlSpan[];
}

export interface SuggestResponse {
  terms: SuggestTerm[];
  indexVersion: number;
}

export interface SearchDatasetItem {
  id: number;
  code: string;
  englishName: string | null;
  entityLevel: string | null;
  name: string;
  sublibrary: string | null;
  topCategoryCode: string | null;
  fullDescSnippet: string | null;
  yearStart: number | null;
  yearEnd: number | null;
  dataFrequency: string | null;
  hasStataCode: boolean;
  hasPythonCode: boolean;
  hasRCode: boolean;
  rowCount: number | null;
  hl: { name: HlSpan[]; code: HlSpan[]; fullDesc: HlSpan[] };
}

export interface SearchFieldItem {
  fieldId: number;
  symbol: string;
  chineseName: string | null;
  descriptionSnippet: string | null;
  fieldType: string | null;
  datasetId: number;
  datasetCode: string;
  datasetName: string;
  topCategoryCode: string | null;
  hl: { symbol: HlSpan[]; chineseName: HlSpan[]; description: HlSpan[] };
}

export interface SearchResponse {
  datasets: {
    items: SearchDatasetItem[];
    total: number;
    page: number;
    pageSize: number;
    sort: 'rel' | 'name' | 'yearStart' | 'rowCount';
  };
  fields: {
    items: SearchFieldItem[];
    total: number;
    page: number;
    pageSize: number;
    sort: 'rel' | 'symbol' | 'datasetCode';
  };
  indexVersion: number;
  counts: Record<string, { datasets: number; fields: number }>;
}

export const searchApi = {
  suggest(q: string, signal?: AbortSignal) {
    return api.get<SuggestResponse>('/search/suggest', { params: { q }, signal });
  },
  search(
    params: {
      q: string;
      cats?: string;
      datasetsPage?: number;
      fieldsPage?: number;
      datasetsSort?: 'rel' | 'name' | 'yearStart' | 'rowCount';
      fieldsSort?: 'rel' | 'symbol' | 'datasetCode';
    },
    signal?: AbortSignal,
  ) {
    return api.get<SearchResponse>('/search', { params, signal });
  },
};

export function renderHighlighted(
  source: string,
  spans: HlSpan[],
): Array<{ text: string; hl: boolean }> {
  if (!source) return [];
  if (!spans || spans.length === 0) return [{ text: source, hl: false }];
  const out: Array<{ text: string; hl: boolean }> = [];
  let cursor = 0;
  for (const [start, len] of spans) {
    if (start > cursor) out.push({ text: source.slice(cursor, start), hl: false });
    out.push({ text: source.slice(start, start + len), hl: true });
    cursor = start + len;
  }
  if (cursor < source.length) out.push({ text: source.slice(cursor), hl: false });
  return out;
}
